export enum UserStatus {
	OPTED_IN = "opted_in",
	OPTED_OUT_HAS_ASSET = "opted_out_has_asset",
	OPTED_OUT_NO_ASSET = "opted_out_no_asset"
}
